import {ExpectedMoveSettings} from "./expected-move.service";
import {isValidNumber, isVoid} from "../utils";

/**
 * Can the currently-configured Range Model be resolved into a band at all?
 *
 * Shared definition for the primary calculation and Co-Pilot gate. The second custom percentage
 * uses this same validator with its percentage substituted. Display queries evaluate each selected
 * band independently, so an invalid Range 1 cannot suppress a valid selected Range 2.
 *
 * False in two reachable states:
 *   - 'Custom Percentage' with no usable percent. `rangeModelCustomPercent` has no default
 *     (`ApplicationSettingsService.initExpectedMoveSettings` back-fills every other field but not
 *     this one) and its box is the only control in the Expected Move fieldset NOT bound to
 *     `[disabled]="!this.enabled"` — so it can be cleared on its own.
 *   - An unrecognised or blank `rangeModel`. `ExpectedMoveSettingsComponent.reset()` nulls it and the
 *     App Settings dialog saves the component's values verbatim, so a null survives for the rest of
 *     the session (the back-fill that would repair it runs only at app load).
 *
 * Kept as a free function over `ExpectedMoveSettings` — the processor holds its own pushed copy of
 * the settings and must not reach back into the service that constructs it.
 */
export function isRangeModelResolvable(settings: ExpectedMoveSettings): boolean {

    if (isVoid(settings)) {
        return false;
    }

    if (settings.rangeModel === 'ATM Straddle') {
        return true;
    }

    if (settings.rangeModel === 'Custom Percentage') {
        // The panel stores a MULTIPLIER of the straddle (0.01-5.0, displayed as 1%-500% by the
        // box's "0#%" format). Zero or negative would collapse or invert the band.
        return isValidNumber(settings.rangeModelCustomPercent)
            && settings.rangeModelCustomPercent > 0;
    }

    return false;
}
